﻿import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import * as eventTypes from '../../../map/utils/eventTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import * as paths from '../../../map/utils/paths';

export default class PrintingControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, modalWrapper, parentId) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.modalWrapper = modalWrapper;
        this.parentId = parentId;
        this.mapMoveEndHandler = this._getMapMoveEndHandler();
        this.printStarted = false;

        this.elementId = `map-action-${classId}-${action.Id}`;
        this.printingWrapper = `printing-wrapper-${classId}-${action.Id}`;
        this.printingPanel = `printing-panel-${classId}-${action.Id}`;
        this.cancelPrintingId = `cancel-printing-${classId}-${action.Id}`;
        this.savePrintingId = `save-printing-${classId}-${action.Id}`;
        this.scaleId = `print-scale-${classId}-${action.Id}`;
        this.compassId = `print-compass-${classId}-${action.Id}`;
        this.legendId = `print-legend-${classId}-${action.Id}`;
        this.legendWrapperId = `print-legend-wrapper-${classId}-${action.Id}`;
        this.dimensionSelectId = `print-dimension-${classId}-${action.Id}`;
        this.resolutionSelectId = `print-resolution-${classId}-${action.Id}`;
        this.formatSelectId = `print-format-${classId}-${action.Id}`;
        this.orientationSelectId = `print-orientation-${classId}-${action.Id}`;

        this.active = false;
        this.actionContent = JSON.parse(this.action.Content);
        this.dim = null;
        this.resolution = 150;
        this.orientation = 'Portrait';
        this.pageSize = 'A4';
        this.format = 'pdf';
        this.handlePageDimension();
    }

    handlePageDimension() {
        if (this.pageSize === 'A5') {
            this.dim = [210, 148.5];
        } else if (this.pageSize === 'A4') {
            this.dim = [297, 210];
        } else if (this.pageSize === 'A3') {
            this.dim = [420, 297];
        } else if (this.pageSize === 'A2') {
            this.dim = [594, 420];
        } else if (this.pageSize === 'A1') {
            this.dim = [841, 594];
        } else if (this.pageSize === 'A0') {
            this.dim = [1189, 841];
        }
    }

    init() {
        if ($('.map-serach-config').length > 0) {
            $('.map-serach-config').addClass('map-search-joined');
        }

        if (this.parentId != null) {
            $('#' + this.parentId)[0].append(this._getGroupedActionButtonTemplate());
        } else {
            this.menuContainer.append(this._getActionButtonTemplate());
        }

        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        $event.register(eventTypes.MAP_MOVE_END, this.mapMoveEndHandler, this, this.classId);
        $event.register(eventTypes.GENERAL_ACTION_SHOW, this._getGeneralActionShowHandler(), this, this.classId);
    }

    _getGeneralActionShowHandler() {
        var handler = (eventName, data, sender) => {
            this._hidePanel();
        };

        return handler;
    }

    _getMapMoveEndHandler() {
        return () => {
            if (!this.active) return;

            if (document.querySelector('.ol-viewport .ol-scale-bar')) {
                const scaleEl = document.querySelector('.ol-viewport .ol-scale-bar').cloneNode(true);
                scaleEl.style.bottom = 'unset';
                scaleEl.style.position = 'relative';
                const targetScale = document.getElementById(this.scaleId);
                if (targetScale) {
                    targetScale.innerHTML = '';
                    targetScale.appendChild(scaleEl);
                }
            }

            const compass = document.querySelector('.ol-compass');
            if (compass && document.getElementById(this.compassId)) {
                const tr = compass.style.transform;
                if (tr) document.getElementById(this.compassId).style.transform = tr;
            }

            if (document.getElementById(this.legendId) && !this.printStarted) {
                this._buildLegend();
            }
        };
    }

    _actionButtonClickHandler() {
        return () => {
            this.active ? this._hidePanel() : this._showPanel();
        };
    }

    _hidePanel() {
        this.active = false;
        document.getElementById(this.modalWrapper).innerHTML = '';
        $('#' + this.elementId).removeClass('selected');
    }

    _showPanel() {
        $('#' + this.elementId).addClass('selected');
        $event.notify(eventTypes.GENERAL_ACTION_SHOW, {}, this, this.classId);

        if (this.parentId != null) {
            $('#' + this.parentId).css('display', 'none');
        }

        this.active = true;
        const wrapper = document.getElementById(this.modalWrapper);
        wrapper.innerHTML = this._getPrintingTemplate();

        let tpl = this.actionContent.template;
        const hasScale = tpl.includes('{scale}');
        const hasCompass = tpl.includes('{compass}');
        const hasLegend = tpl.includes('{legend}');
        tpl = tpl.replaceAll('{scale}', `<div id="${this.scaleId}"></div>`);
        tpl = tpl.replaceAll('{compass}', `<div id="${this.compassId}"></div>`);
        tpl = tpl.replaceAll('{legend}', `<div id="${this.legendId}" class="print-legend-wrapper"></div>`);

        while (tpl.indexOf('{value:') > 0) {
            let startIndex = tpl.indexOf('{value:');
            let endIndex = tpl.indexOf('}');
            let valueTag = tpl.substr(startIndex, endIndex - startIndex + 1);

            let valueName = valueTag.replaceAll('{', '').replaceAll('}', '').split(':')[1];

            tpl = tpl.replaceAll(valueTag, '<span contenteditable="true" style="pointer-events: all;">' + valueName + '</span>');
        }

        document.getElementById(this.printingPanel).innerHTML = tpl;

        if (hasScale) {
            const scaleEl = document.querySelector('.ol-viewport .ol-scale-bar').cloneNode(true);
            scaleEl.style.bottom = 'unset';
            scaleEl.style.position = 'relative';
            document.getElementById(this.scaleId).appendChild(scaleEl);
        }

        if (hasCompass) {
            document.getElementById(this.compassId).innerHTML =
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="100" height="100">
                    <circle cx="20" cy="20" r="18" fill="rgba(0,0,0,0.2)"/>
                    <polygon points="20,6 16,20 20,20 24,20" fill="#ea4335"/>
                    <polygon points="20,34 24,20 20,20 16,20" fill="#888"/>
                    <circle cx="20" cy="20" r="2" fill="#555"/>
                </svg>`;

            const compass = document.querySelector('.ol-compass');
            if (compass && document.getElementById(this.compassId)) {
                const tr = compass.style.transform;
                if (tr) document.getElementById(this.compassId).style.transform = tr;
            }
        }

        let availH = window.innerHeight;
        let paneH = availH - 80;
        let paneW = paneH / 1.414;
        const panelEl = document.getElementById(this.printingPanel);
        panelEl.style.height = `${paneH}px`;
        panelEl.style.width = `${paneW}px`;

        document.getElementById(this.cancelPrintingId).addEventListener('click', () => this._hidePanel());
        document.getElementById(this.savePrintingId).addEventListener('click', () => this._printMap());

        if (hasLegend) {
            this._buildLegend();
        }

        $('#' + this.orientationSelectId).on('change', () => {
            let value = $('#' + this.orientationSelectId).val();

            if (value == null || value == '' || value == 'Orientation') {
                value = 'Portrait';
            }

            availH = window.innerHeight;
            paneH = value === 'Landscape' ? (availH - 130) : (availH - 80);
            paneW = value === 'Landscape' ? paneH * 1.414 : paneH / 1.414;

            panelEl.style.height = `${paneH}px`;
            panelEl.style.width = `${paneW}px`;
            this.orientation = value;

            $('.no-scale.full-row').css('width', `${paneW}px`);
        });

        $('#' + this.resolutionSelectId).on('change', () => {
            let value = $('#' + this.resolutionSelectId).val();

            if (value == null || value == '' || value == 'Resolution') {
                this.resolution = 150;
            } else {
                this.resolution = value * 1;
            }
        });

        $('#' + this.dimensionSelectId).on('change', () => {
            let value = $('#' + this.dimensionSelectId).val();

            if (value == null || value == '' || value == 'PageSize') {
                this.pageSize = 'A4';
            } else {
                this.pageSize = value;
            }

            this.handlePageDimension();
        });

        $('#' + this.formatSelectId).on('change', () => {
            let value = $('#' + this.formatSelectId).val();

            if (value == null || value == '' || value == 'Format') {
                this.format = 'pdf';
            } else {
                this.format = value;
            }
        });

        $('.no-scale.full-row').css('width', `${paneW}px`);
    }

    _buildLegend() {
        let layers = this.mapControl.selectionHandler.getVisibleLayersInExtent(this._getPrintExtent());

        if (layers != null && layers.length > 0) {
            let template = [];

            let paddingLeft = 0;

            layers.forEach(layer => {
                this._buildLegendNode(template, layer, paddingLeft);
            });

            $('#' + this.legendId)[0].innerHTML = template.join('');
        }
    }

    _buildLegendNode(template, layer, paddingLeft) {
        if (layer.Type != layerTypes.GROUP && !layer.hasClassification) {
            template.push(`<div class="map-print-layer" style="padding-left: ` + paddingLeft + `px; margin-bottom: 0.1rem;">` + this._getPrintLegendIcon(layer) + `<span class="map-print-layer-name" style="font-size: 0.9rem;">` + layer.Title + `</span></div>`);
        }
        
        if (layer.Items != null && layer.Items.length > 0) {
            layer.Items.forEach(child => {
                //this._buildLegendNode(template, child, paddingLeft + 15);
                this._buildLegendNode(template, child, paddingLeft);
            });
        }

        if (layer.hasClassification && layer.usedClassifications != null) {
            let usedClassifications = Object.keys(layer.usedClassifications);

            usedClassifications.forEach(usedClassification => {
                let idx = usedClassification * 1;
                if (idx < layer.classifications.length) {
                    let classification = layer.classifications[idx];
                    template.push(`<div class="map-print-layer" style="padding-left: ` + paddingLeft + `px; margin-bottom: 0.1rem;">` + this._getClassificationIcon(layer, classification) + `<span class="map-print-layer-name" style="font-size: 0.9rem;">` + classification.name + `</span></div>`);
                }
            });
        }
    }

    _getClassificationIcon(layer, classification) {
        return `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (rootURL + 'img/style/' + layer.IdDefaultStyle + '_' + classification.idx + '.png') + `"></img>`;
    }

    _getPrintLegendIcon(layer) {
        let template = ``;

        if (layer.Id == layerTypes.MEASUREMENTS) {
            template = `<span class="fal fa-ruler legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Id == layerTypes.DIMENSIONING) {
            template = `<span class="fal fa-arrows-h legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Id == layerTypes.REDLINE) {
            template = `<span class="fal fa-pencil-paintbrush legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Type == layerTypes.GROUP) {
            //template = `<span class="fal fa-object-group legend-preview-icon" style="font-size: 1rem;"></span>`;
        } else if (layer.Type == layerTypes.GEOSERVICE) {
            if (layer.Geoservice.LegendUrl != null && layer.Geoservice.LegendUrl.trim() != '') {
                template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.PROXY_URL + this.mapId + '/' + layer.Fid.replaceAll('-', '') + layer.Geoservice.LegendUrl) + `"></img>`;
            } else {
                template = `<span class="fal fa-globe legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
            }
        }

        if (layer.IdDefaultStyle != null && layer.IdDefaultStyle > 0) {
            template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', layer.IdDefaultStyle).replaceAll('{rule}', 0)) + `"></img>`;
        }

        return template;
    }

    _getPrintExtent() {
        let map = this.mapControl.map;
        let container = map.getTargetElement();
        let panelEl = document.getElementById(this.printingPanel);

        let printRect = panelEl.getBoundingClientRect();

        let mapRect = container.getBoundingClientRect();
        let overlayLeft = printRect.left - mapRect.left;
        let overlayTop = printRect.top - mapRect.top;
        let overlayWidth = printRect.width;
        let overlayHeight = printRect.height;
        let topLeft = map.getCoordinateFromPixel([overlayLeft, overlayTop]);
        let bottomRight = map.getCoordinateFromPixel([overlayLeft + overlayWidth, overlayTop + overlayHeight]);
        return [
            Math.min(topLeft[0], bottomRight[0]),
            Math.min(topLeft[1], bottomRight[1]),
            Math.max(topLeft[0], bottomRight[0]),
            Math.max(topLeft[1], bottomRight[1])
        ];
    }

    _getPrintingTemplate() {
        return `<div class="general-settings-wrapper panel printing-pane-wrapper" id="${this.printingWrapper}">
            <div class="general-settings-panel panel-container printing-pane" style="background-color: transparent; pointer-events: none;">
                <div class="form-row general-settings-title-row m-0 col-12">
                    <label class="form-label general-settings-title mt-2">${this.resourcesHandler.get('PrintMap')}</label>
                </div>
                <div class="panel-content p-0 printing-pane-content" id="${this.printingPanel}" style="background-color: transparent;"></div>
                <div class="printing-buttons panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right" style="padding: 0.5rem;">
                    <select class="print-select" id="${this.dimensionSelectId}">
                        <option value="PageSize">` + this.resourcesHandler.get('PageSize') + `</option>
                        <option value="A0">A0</option>
                        <option value="A1">A1</option>
                        <option value="A2">A2</option>
                        <option value="A3">A3</option>
                        <option value="A4">A4</option>
                        <option value="A5">A5</option>
                    </select>
                    <select class="print-select" id="${this.resolutionSelectId}" style="margin-left: 0.5rem;">
                        <option value="Resolution">` + this.resourcesHandler.get('Resolution') + `</option>
                        <option value="72">72 dpi</option>
                        <option value="150">150 dpi</option>
                        <option value="200">200 dpi</option>
                        <option value="300">300 dpi</option>
                    </select>
                    <select class="print-select" id="${this.formatSelectId}" style="margin-left: 0.5rem;">
                        <option value="Format">` + this.resourcesHandler.get('Format') + `</option>
                        <option value="pdf">pdf</option>
                        <option value="png">png</option>
                        <option value="jpg">jpg</option>
                    </select>
                    <select class="print-select" id="${this.orientationSelectId}" style="margin-left: 0.5rem;">
                        <option value="Orientation">` + this.resourcesHandler.get('Orientation') + `</option>
                        <option value="Portrait">` + this.resourcesHandler.get('Portrait') + `</option>
                        <option value="Landscape">` + this.resourcesHandler.get('Landscape') + `</option>
                    </select>
                    <button style="padding: 0.1rem !important;" id="${this.cancelPrintingId}" class="btn btn-secondary ml-auto" title="${this.resourcesHandler.get('CancelChanges')}" type="button">${this.resourcesHandler.get('Cancel')}</button>
                    <button style="padding: 0.1rem !important;" id="${this.savePrintingId}" class="btn btn-primary ml-2" title="${this.resourcesHandler.get('Print')}" type="button">${this.resourcesHandler.get('Print')}</button>
                </div>
            </div>
        </div>`;
    }

    _printMap() {
        Swal.fire({ allowOutsideClick: false, onBeforeOpen: () => Swal.showLoading() });
        this.printStarted = true;
        const dpi = this.resolution;
        const mmPerInch = 25.4;
        const [hMm, wMm] = this.dim;
        const isPortrait = this.orientation === 'Portrait';
        const pageWmm = isPortrait ? wMm : hMm;
        const pageHmm = isPortrait ? hMm : wMm;
        const printCssPx = [
            Math.round(pageWmm * dpi / mmPerInch),
            Math.round(pageHmm * dpi / mmPerInch)
        ];

        const map = this.mapControl.map;
        const view = map.getView();
        const container = map.getTargetElement();
        const panelEl = document.getElementById(this.printingPanel);

        const printRect = panelEl.getBoundingClientRect();
        const origOverlayStyle = panelEl.getAttribute('style');
        const staticEls = Array.from(panelEl.querySelectorAll('.no-scale')).map(el => ({
            el,
            inlineStyle: el.getAttribute('style')
        }));

        const mapRect = container.getBoundingClientRect();
        const overlayLeft = printRect.left - mapRect.left;
        const overlayTop = printRect.top - mapRect.top;
        const overlayWidth = printRect.width;
        const overlayHeight = printRect.height;
        const topLeft = map.getCoordinateFromPixel([overlayLeft, overlayTop]);
        const bottomRight = map.getCoordinateFromPixel([overlayLeft + overlayWidth, overlayTop + overlayHeight]);
        const extent = [
            Math.min(topLeft[0], bottomRight[0]),
            Math.min(topLeft[1], bottomRight[1]),
            Math.max(topLeft[0], bottomRight[0]),
            Math.max(topLeft[1], bottomRight[1])
        ];

        const originalCenter = view.getCenter();
        const originalResolution = view.getResolution();
        const originalRotation = view.getRotation();

        container.style.width = `${printCssPx[0]}px`;
        container.style.height = `${printCssPx[1]}px`;
        map.updateSize();
        view.fit(extent, { size: printCssPx, constrainResolution: false });

        map.once('rendercomplete', () => {
            setTimeout(() => {
                if (document.querySelector('.ol-viewport .ol-scale-bar')) {
                    const scaleEl = document.querySelector('.ol-viewport .ol-scale-bar').cloneNode(true);
                    scaleEl.style.bottom = 'unset';
                    scaleEl.style.position = 'relative';
                    const targetScale = document.getElementById(this.scaleId);
                    if (targetScale) {
                        targetScale.innerHTML = '';
                        targetScale.appendChild(scaleEl);
                    }
                }

                const dpr = window.devicePixelRatio || 1;
                const resolutionScale = dpi / 96;
                const S = dpr * resolutionScale;

                const size = map.getSize();
                const printCanvas = document.createElement('canvas');
                printCanvas.width = size[0] * S;
                printCanvas.height = size[1] * S;
                const ctx = printCanvas.getContext('2d');
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';

                container.querySelectorAll('canvas.ol-layer, .ol-layer canvas').forEach(layerCanvas => {
                    if (!layerCanvas.width) return;
                    ctx.globalAlpha = Number(layerCanvas.parentNode.style.opacity || layerCanvas.style.opacity || 1);
                    const tr = layerCanvas.style.transform;
                    const m = /^matrix\(/.test(tr)
                        ? tr.match(/^matrix\(([^\)]+)\)$/)[1].split(',').map(Number)
                        : [parseFloat(layerCanvas.style.width) / layerCanvas.width, 0, 0, parseFloat(layerCanvas.style.height) / layerCanvas.height, 0, 0];
                    const mat = [m[0] * S, m[1] * S, m[2] * S, m[3] * S, m[4] * S, m[5] * S];
                    ctx.setTransform(...mat);
                    const bg = layerCanvas.parentNode.style.backgroundColor;
                    if (bg) {
                        ctx.fillStyle = bg;
                        ctx.fillRect(0, 0, layerCanvas.width, layerCanvas.height);
                    }
                    ctx.drawImage(layerCanvas, 0, 0, layerCanvas.width, layerCanvas.height);
                });

                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.globalAlpha = 1;

                panelEl.style.width = `${printCssPx[0]}px`;
                panelEl.style.height = `${printCssPx[1]}px`;
                panelEl.style.transform = '';
                panelEl.style.transformOrigin = '';

                const scaleX = printCssPx[0] / printRect.width;
                const scaleY = printCssPx[1] / printRect.height;

                staticEls.forEach(({ el }) => {
                    let transformOrigin = '';
                    let isTop = true;
                    let isLeft = true;

                    if (el.style.bottom != null && el.style.bottom.trim() != '') {
                        isTop = false;
                    }

                    if (el.style.right != null && el.style.right.trim() != '') {
                        isLeft = false;
                    }

                    if (isTop) {
                        transformOrigin = 'top';
                    } else {
                        transformOrigin = 'bottom';
                    }

                    if (isLeft) {
                        transformOrigin += ' left';
                    } else {
                        transformOrigin += ' right';
                    }

                    el.style.transformOrigin = transformOrigin;
                    el.style.transform = `scale(${scaleX}, ${scaleY})`;
                });

                html2canvas(panelEl, {
                    backgroundColor: null,
                    scale: 1,
                    width: printCssPx[0],
                    height: printCssPx[1]
                }).then(overlayCanvas => {
                    ctx.drawImage(overlayCanvas, 0, 0, printCssPx[0] * S, printCssPx[1] * S);
                    Swal.close();
                    view.setCenter(originalCenter);
                    view.setResolution(originalResolution);
                    view.setRotation(originalRotation);
                    container.style.width = '';
                    container.style.height = '';
                    map.updateSize();

                    if (origOverlayStyle !== null) {
                        panelEl.setAttribute('style', origOverlayStyle);
                    } else {
                        panelEl.removeAttribute('style');
                    }
                    staticEls.forEach(({ el, inlineStyle }) => {
                        if (inlineStyle !== null) {
                            el.setAttribute('style', inlineStyle);
                        } else {
                            el.removeAttribute('style');
                        }
                    });
                    this.printStarted = false;

                    if (this.format == 'pdf') {
                        const pdf = new jsPDF(
                            this.orientation.toLowerCase(),
                            'mm',
                            this.pageSize.toLowerCase()
                        );
                        pdf.addImage(printCanvas.toDataURL('image/png'), 'PNG', 0, 0, pageWmm, pageHmm);
                        pdf.autoPrint();

                        window.open(pdf.output('bloburl'));
                    } else if (this.format == 'png') {
                        let imgData = printCanvas.toDataURL('image/png');
                        let imgWin = window.open('');

                        imgWin.document.write(`
                            <html>
                              <head>
                                <title>Print Preview</title>
                                <style>
                                  /* make sure the image fills the page */
                                  html, body { margin: 0; padding: 0; }
                                  img { display: block; width: 100%; height: auto; }
                                </style>
                              </head>
                              <body>
                                <img src="${imgData}"
                                     onload="window.print();" />
                              </body>
                            </html>
                        `);
                    } else if (this.format == 'jpg') {
                        let imgData = printCanvas.toDataURL('image/jpg');
                        let imgWin = window.open('');

                        imgWin.document.write(`
                            <html>
                              <head>
                                <title>Print Preview</title>
                                <style>
                                  /* make sure the image fills the page */
                                  html, body { margin: 0; padding: 0; }
                                  img { display: block; width: 100%; height: auto; }
                                </style>
                              </head>
                              <body>
                                <img src="${imgData}"
                                     onload="window.print();" />
                              </body>
                            </html>
                        `);
                    }
                });
            });
        });
    }

    _clipCanvas(inputCanvas, x, y, width, height) {
        const output = document.createElement('canvas');
        output.width = width;
        output.height = height;
        const ctx = output.getContext('2d');
        ctx.drawImage(inputCanvas, x, y, width, height, 0, 0, width, height);
        return output;
    }

    _getGroupedActionButtonTemplate() {
        const div = document.createElement('div');
        div.innerHTML = `<li><a class="dropdown-item" id="${this.elementId}" title="${this._getTitle()}"><i class="${this.action.Icon}" style="margin-right: 0.5rem;"></i>${this._getTitle()}</a></li>`;
        return div.firstChild;
    }

    _getActionButtonTemplate() {
        const div = document.createElement('div');
        div.innerHTML = `<li><a class="btn map-menu-item" id="${this.elementId}" title="${this._getTitle()}"><i class="${this.action.Icon}"></i></a></li>`;
        return div.firstChild;
    }

    _getTitle() {
        return this.action.Title || this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}
